import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useT } from '../i18n/useT';
// [F-CANDTRACK] Jelentkezés-követő timeline a job detail oldal tetején (tokenes érkezés).
// A jelölt SOSEM belső státusz-neveket lát, csak fázis-csoportokat; a címkék
// admin-szerkeszthető fordítási kulcsok (Miniapp szövegek).
const STAGE_FALLBACKS = {
    applied: 'Jelentkezés beérkezett',
    screening: 'Egyeztetés alatt',
    interview: 'Interjú',
    offer: 'Ajánlat',
    hired: 'Felvéve',
    rejected: 'Elutasítva',
};
function formatDate(date) {
    const lang = (typeof window !== 'undefined' && window.__CAREER_CONFIG__?.site?.lang) || 'hu';
    const parsed = new Date(`${date}T00:00:00`);
    if (isNaN(parsed.getTime()))
        return date;
    return parsed.toLocaleDateString(lang === 'hu' ? 'hu-HU' : 'en-GB');
}
export function ApplyStatusTimeline({ status }) {
    const { t } = useT();
    if (!status || !status.found)
        return null;
    const items = [
        { key: 'applied', date: status.applied_at || '' },
        ...(status.stages || []),
    ];
    const currentKey = status.current_stage || 'applied';
    return (_jsxs("section", { className: "career-apply-status", "data-testid": "apply-status-timeline", children: [_jsx("h3", { "data-translate": "apply_status_heading", children: t('apply_status_heading', 'Jelentkezésed állapota') }), _jsx("ol", { className: "career-apply-status-track", children: items.map(item => (_jsxs("li", { className: 'career-apply-status-step'
                        + (item.key === currentKey ? ' is-current' : '')
                        + (item.key !== currentKey && item.date ? ' is-done' : '')
                        + (item.key === 'rejected' ? ' is-rejected' : ''), ...(item.key === currentKey ? { 'aria-current': 'step' } : {}), children: [_jsx("span", { className: "career-apply-status-dot", "aria-hidden": "true" }), _jsx("span", { className: "career-apply-status-label", "data-translate": `apply_status_stage_${item.key}`, children: t(`apply_status_stage_${item.key}`, STAGE_FALLBACKS[item.key] || item.key) }), item.date && (_jsx("span", { className: "career-apply-status-date", children: formatDate(item.date) }))] }, item.key))) })] }));
}
